import React, { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { RuleConfirmationProps } from "../../Interfaces/interfaces";

const RuleConfirmationDialog: React.FC<RuleConfirmationProps> = ({
  Title,
  visible,
  onHide,
  onSave,
  whitelistRule,
}) => {
  const [loading, setLoading] = useState(false);
  const toast = useRef<Toast>(null);

  const handleSave = async () => {
    if (!whitelistRule || Array.isArray(whitelistRule)) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Invalid rule data. Cannot save.",
        life: 3000,
      });
      return;
    }

    setLoading(true);
    try {
      // Send the updated rule to the API
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Rule updated successfully.",
        life: 3000,
      });
      onSave(whitelistRule); // Ensure this is handled in the parent component
      onHide(); // Close the confirmation dialog
    } catch (error) {
      console.error("Error updating rule:", error); // Log the error for debugging
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to update the rule. Please try again.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      header={Title}
      visible={visible}
      onHide={onHide}
      footer={
        <div>
          <Button
            label="Yes"
            onClick={handleSave}
            loading={loading}
          />
          <Button label="No" onClick={onHide} className="ml-2" />
        </div>
      }
      style={{ width: "20%" }}
    >
      {/* Add meaningful content or form fields here */}
      <div className="p-fluid p-formgrid p-grid">
        {/* You can add content such as a confirmation message */}
      </div>

      <Toast ref={toast} />
    </Dialog>
  );
};

export default RuleConfirmationDialog;
